<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5"
      i18n="@@gasWarningCenterConfiguration.selectGasWarningCenter.modules.header"
      data-testid="gasWarningCenterConfiguration.selectGasWarningCenter.modules.header"
    >
      Module für Gaswarnzentrale auswählen
    </h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>

  <odx-content-box class="flex-scroll">
    @if (inputModules$ | async) {
      <h6 class="odx-title-6" i18n="@@productConfiguration.gasWarningCenter.inputModules.header">Eingabemodule</h6>

      <form [formGroup]="inputModuleForm">
        <odx-radio-group formControlName="inputModules">
          <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100">
            @for (inputModule of filteredInputModules(); track inputModule.id) {
              <app-product-card-with-quantity
                class="overflow-hidden"
                [productData]="inputModule"
                [showCosts]="project.showCostFlag"
                selectionMode="multi"
                [quantity]="getSelectedQuantity(inputModuleForm.value.inputModules, inputModule)"
                (quantityChanged$)="updateSelectedInputModules($event, inputModule)"
              >
                @if (inputModule.id) {
                  <div class="feature">
                    <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                    <p class="odx-text--small">{{ inputModule.id }}</p>
                  </div>
                }
              </app-product-card-with-quantity>
            }
          </div>
        </odx-radio-group>
      </form>
    }

    @if (relayModules$ | async) {
      <h6 class="odx-title-6" i18n="@@productConfiguration.gasWarningCenter.relayModules.header">Relaismodule</h6>
      <form [formGroup]="relayModuleForm">
        <odx-radio-group formControlName="relayModules">
          <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100">
            @for (relayModule of filteredRelayModules(); track relayModule.id) {
              <app-product-card-with-quantity
                class="overflow-hidden"
                [productData]="relayModule"
                [showCosts]="project.showCostFlag"
                selectionMode="multi"
                [quantity]="getSelectedQuantity(relayModuleForm.value.relayModules, relayModule)"
                (quantityChanged$)="updateSelectedRelayModules($event, relayModule)"
              >
                @if (relayModule.id) {
                  <div class="feature">
                    <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                    <p class="odx-text--small">{{ relayModule.id }}</p>
                  </div>
                }
              </app-product-card-with-quantity>
            }
          </div>
        </odx-radio-group>
      </form>
    }

    @if (gatewayModules$ | async) {
      <h6 class="odx-title-6" i18n="@@productConfiguration.gasWarningCenter.gatewayModules.header">Gatewaymodule</h6>

      <form [formGroup]="gatewayModuleForm">
        <odx-radio-group formControlName="gatewayModules">
          <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100">
            @for (gatewayModule of filteredGatewayModules(); track gatewayModule.id) {
              <app-product-card-with-quantity
                class="overflow-hidden"
                [productData]="gatewayModule"
                [showCosts]="project.showCostFlag"
                selectionMode="multi"
                [quantity]="getSelectedQuantity(gatewayModuleForm.value.gatewayModules, gatewayModule)"
                (quantityChanged$)="updateSelectedGatewayModules($event, gatewayModule)"
              >
                @if (gatewayModule.id) {
                  <div class="feature">
                    <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                    <p class="odx-text--small">{{ gatewayModule.id }}</p>
                  </div>
                }
              </app-product-card-with-quantity>
            }
          </div>
        </odx-radio-group>
      </form>
    }

    @if (filteredInputModules().length === 0 && filteredRelayModules().length === 0 && filteredGatewayModules().length === 0) {
      <app-refresh-products-hint dataType="Module" i18n-dataType="@@global.modules"></app-refresh-products-hint>
    }
  </odx-content-box>
</div>
